$(document).ready(function() {

  $('[destroy-button]').on('click', function(){
    destroy($(this));
  });

  $('input[type="radio"][name="type"]:checked').trigger('click');

});

function parseDate(date) {
    return new Date(date);
}

window.formatDate = function(date, format = 'dd/MM/yyyy HH:mm:ss') {
    if (isEmptyOrNull(date)) {
        return '';
    }
    date = parseDate(date);
    return date.toString(format);
};

window.checkAll = function (element) {
    const value = $(element).prop('checked');
    $('input[type=checkbox]').prop('checked', value);
};

function isEmptyOrNull(data) {
    return (data == null || data == '');
}

function destroy($button) {
  bootbox.confirm({
    title: 'Excluir Registro',
    message: $button.data('message'),
    buttons: {
      'cancel': {
        label: 'Não',
        className: 'btn-default float-left'
      },
      'confirm': {
        label: 'Sim',
        className: 'btn-outline-secondary float-right'
      }
    },
    callback: function(result) {
      if (result) {
        $button.parent().submit();
      }
    }
  });
}



// WEBPACK FOOTER //
// ./resources/assets/js/app.js